export const mockItems = Array.from({ length: 20 }, (_, index) => {
  const indexString = `${index + 1}`.padStart(2, "0");

  return {
    id: `item-${indexString}`,
    title: `Item ${indexString}`,
    value: indexString,
  };
});
